import { NgModule } from '@angular/core';
import { CareerSurveysEntitiesState, CareerHousesEntitiesState, CareerInterestsEntitiesState, CareerSurveyResultsEntitiesState, CareerThreadsEntitiesState } from './state';
import { NgxsModule } from '@ngxs/store';

@NgModule({
  imports: [
    NgxsModule.forFeature([CareerInterestsEntitiesState, CareerThreadsEntitiesState, CareerHousesEntitiesState, CareerSurveyResultsEntitiesState, CareerSurveysEntitiesState]),
  ],
  providers: [],
  declarations: [],
  exports: [],
})
export class CareersModule {}
